<template>
  <AddAgencyForm
    submitUrl="/api/register/set-up-agency"
    :onSuccessfulSubmit="handleSuccessfulSubmit"
  >
    <template #progress-bar>
      <CompleteSignupProgressRegular :currentStep="2" />
    </template>
  </AddAgencyForm>
</template>

<script>
import { isConfirmTokenPresent, showSessionExpiredWarning } from '@utils/confirmationToken'
import AddAgencyForm from '@components/sign-up/AddAgencyForm.vue'
import CompleteSignupProgressRegular from '@components/sign-up/complete-signup-progress/CompleteSignupProgressRegular.vue'

export default {
  name: 'AddAgency',
  components: {
    CompleteSignupProgressRegular,
    AddAgencyForm
  },
  mounted () {
    // Show warning message on page load if no confirmation cookie
    if (!isConfirmTokenPresent(this.$cookies)) {
      showSessionExpiredWarning(this)
    }
  },
  methods: {
    handleSuccessfulSubmit () {
      this.$router.replace({ name: this.ROUTES.INVITE_TEAMMATES.name })
    }
  }
}
</script>
